import { useTheme } from '@material-ui/core';
import { ModeTokens, dark, light } from './tokens';

/**
 * Returns the design tokens for the currently active theme mode.
 *
 * Page components use this instead of hardcoding hex values so surfaces,
 * accents and semantic tones stay in lockstep with `tokens.ts` and flip
 * correctly between light and dark.
 */
export function useTokens(): ModeTokens {
  const theme = useTheme();
  return theme.palette.type === 'dark' ? dark : light;
}
